import React from 'react';
import api from '../api/axios';

function routeType(pathname = '') {
  const path = String(pathname || '');
  if (/^\/campaigns\/[^/]+\/agent/.test(path)) return '/campaigns/:id/agent';
  if (/^\/campaigns\/[^/]+\/sourcing/.test(path)) return '/campaigns/:id/sourcing';
  if (/^\/campaigns\/[^/]+/.test(path)) return '/campaigns/:id';
  if (/^\/leads\/[^/]+/.test(path)) return '/leads/:id';
  if (/^\/messages/.test(path)) return '/messages';
  if (/^\/operations/.test(path)) return '/operations';
  return path.split('?')[0].slice(0, 120) || '/';
}

function bounded(value, max = 400) {
  return String(value || '').replace(/https?:\/\/[^\s)\]}>]+/gi, '[url]').slice(0, max);
}

async function reportClientCrash(error, info, errorId) {
  try {
    await api.post('/operations/client-errors', {
      errorId: bounded(errorId, 80),
      errorName: bounded(error?.name || 'Error', 80),
      message: bounded(error?.message || 'Client render error', 500),
      routeType: routeType(window.location?.pathname),
      componentStack: bounded(info?.componentStack || '', 1200),
      buildId: String(process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA || process.env.REACT_APP_BUILD_SHA || '').slice(0, 80) || null,
    });
  } catch {
    // Error reporting must never cause a second user-visible failure.
  }
}

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorId: null };
  }

  static getDerivedStateFromError(error) {
    return { error, errorId: `client-${Date.now().toString(36)}` };
  }

  componentDidCatch(error, info) {
    console.error('[AppErrorBoundary] Unhandled render error:', error);
    reportClientCrash(error, info, this.state.errorId);
  }

  retry = () => {
    this.setState({ error: null, errorId: null });
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="min-h-screen bg-gray-50 px-4 py-16 sm:px-6">
        <section className="mx-auto max-w-xl rounded-2xl border bg-white p-6 shadow-sm">
          <p className="text-xs font-semibold uppercase tracking-[.16em] text-rose-600">Paginafout</p>
          <h1 className="mt-2 text-xl font-bold text-gray-950">Deze pagina kon niet worden geladen.</h1>
          <p className="mt-2 text-sm leading-6 text-gray-600">De fout is veilig geregistreerd voor diagnose. Probeer de pagina opnieuw te laden. Als het probleem blijft terugkomen, kan support het fout-ID gebruiken om de oorzaak terug te vinden.</p>
          <div className="mt-4 rounded-lg bg-gray-50 px-3 py-2 font-mono text-xs text-gray-500">{this.state.errorId}</div>
          <div className="mt-5 flex flex-wrap gap-2">
            <button type="button" onClick={this.retry} className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white">Opnieuw laden</button>
            <a href="/" className="rounded-lg border bg-white px-4 py-2 text-sm font-semibold text-gray-700">Naar dashboard</a>
          </div>
        </section>
      </main>
    );
  }
}

export { routeType, bounded, reportClientCrash };
export default AppErrorBoundary;
